// extracted by mini-css-extract-plugin
export default {"title":"system-error_title_EbTuC"};